import { lazy } from 'react';
import withSuspense from '../../helpers/withSuspense';

const TranslationTerms = withSuspense(lazy(() => import('./TranslationTerms.jsx')));

export default TranslationTerms;
